const roundUp = (number, roundUpTo = 10000) => (Math.floor(number / roundUpTo) + 1) * roundUpTo;

function arraySlice(array, topValue, restLabel) {
    const sortedArray = array.sort((a, b) => b.values[0] - a.values[0]);

    const topValues = sortedArray.slice(0, topValue);
    const rest = sortedArray.slice(topValue);

    const otherValue = rest.reduce((sum, item) => sum + item.values[0], 0);
    const other = { label: restLabel, values: [otherValue] };

    return [...topValues, other];
}

// Pie Data Utils
function calculateAngles(data) {
    const totalValue = data.reduce((sum, item) => sum + item.values[0], 0);

    let currentAngle = 0;

    return data.map((item) => {
        const angle = (item.values[0] / totalValue) * 360;

        const start_angle = currentAngle;
        const end_angle = currentAngle + angle;

        currentAngle = end_angle;

        return {
            label: item.label,
            start_angle: start_angle,
            end_angle: end_angle,
            values: [item.values[0]],
        };
    });
}

const preparePieData = (initialState, data) => {
    const resultData = data.map((item) => ({
        label: item.label,
        values: item.values,
    }));

    return {
        ...initialState,
        // BUG WHEN LESS THEN 5
        data: calculateAngles(arraySlice(resultData, 5, "Інше")),
        tableData: calculateAngles(resultData),
        colors: [
            "#ABC6C7", // зелений
            "#BB9BCD", // фіолетовий
            "#EBD084", // жовтий
            "#DB8E8B", // червоний
            "#85B2E4", // синій
            "#EDEDEE", // сірий
        ],
        shadowColors: [
            "#8EA2A3", // затемнений зелений
            "#9A7DAE", // затемнений фіолетовий
            "#C7B066", // затемнений жовтий
            "#B5706F", // затемнений червоний
            "#6E91C2", // затемнений синій
            "#B3B3B3", // затемнений сірий
        ],
    };
};

// Bar Data Utils
const findMaxValueTwoDimensions = (data) => {
    if (data.length === 0) {
        return 0;
    }

    let maxValue = -1;

    data.forEach((item) => {
        let maxInRow = 0;
        for (let i = 0; i < item.values.length; i++) {
            if (item.values[i] > maxInRow) {
                maxInRow = item.values[i];
            }
        }

        if (maxInRow > maxValue) {
            maxValue = maxInRow;
        }
    });

    return maxValue;
};

const prepareBarData = (initialState, data) => {
    const resultData = data.map((item) => ({
        label: item.label,
        values: item.values,
    }));

    const maxValue = findMaxValueTwoDimensions(resultData);
    let maxHeight = 10;
    if (maxValue > 10) {
        maxHeight = Math.floor(roundUp(maxValue, 10 ** (parseInt(maxValue).toString().length - 1)));
    }

    return {
        ...initialState,
        data: resultData,
        widthCoefficient: (initialState.pxWidth * 0.887) / resultData.length,
        heightCoefficient: maxHeight / (initialState.pxHeight * 0.8),
        maxHeight: maxHeight,
    };
};

// Horizontal Bar Data Utils
const prepareHorizontalBarData = (initialState, data) => {
    const resultData = data.map((item) => ({
        label: item.label,
        values: item.values,
    }));

    const sum = resultData.reduce((sum, item) => sum + item.values[0], 0);

    return {
        ...initialState,
        data: resultData,
        widthCoefficient: sum / (initialState.pxWidth * 0.6),
        heightCoefficient: initialState.pxHeight / resultData.length,
        totalSum: sum,
    };
};

export { prepareBarData, preparePieData, prepareHorizontalBarData };
